export default __webpack_public_path__ + "static/media/imd-erp.0999f7c0.jpg";